import { render } from "./ChoixBinaire.vue?vue&type=template&id=02afe5c5"
import script from "./ChoixBinaire.vue?vue&type=script&lang=js"
export * from "./ChoixBinaire.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__